import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'
import ProductSlider from 'src/components/containers/configurator/ProductSlider'
import ProductCard from '../../molecules/configurator/ProductCard'
import ProductCardSmall from '../../molecules/configurator/ProductCardSmall'

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class FuneralCeremony extends React.Component<Props> {
  render() {
    const { confStore, index } = this.props
    const ceremony = confStore.getCatalogue.getProductsByType('CEREMONY')
    const ceremonyOthers = confStore.getCatalogue.getProductsByType(
      'CEREMONY_OTHER'
    )

    const ceremonyProducts = !!ceremony && (
      <>
        {ceremony.map((c, index) => {
          return <ProductCard horizontal product={c} key={c.uuid} idLabel={`ceremony-${index}`} />
        })}
      </>
    )

    const otherProducts = !!ceremonyOthers && (
      <ProductSlider header='Mehr Optionen'>
        {ceremonyOthers.map((c, index) => {
          return <ProductCardSmall product={c} key={c.uuid} idLabel={`otherceremony-${index}`} />
        })}
      </ProductSlider>
    )

    return (
      <ConfiguratorBox collapsable title={`${index}. Zeremonie`} idLabel={`expand-arrow-${index}`} >
        <Grid>
          {ceremonyProducts}
          {otherProducts}
        </Grid>
      </ConfiguratorBox>
    )
  }
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 15px;
  grid-auto-rows: minmax(270px, auto);
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/FuneralCeremony.tsx